export default __webpack_public_path__ + "static/media/laundroEmailLogo.9065a918.png";